<template>
  <app-modal
    v-bind="$attrs"
    ref="modal"
    class="modal-container test"
    content-class="modal-medium"
    title="ワンタイムURL発行"
  >
    <template v-slot:body="{ cancel }">
      <validation-observer v-slot="{ handleSubmit }" as="div">
        <v-form novalidate @submit.stop.prevent="handleSubmit(submit)">
          <!-- BODY -->
          <v-card-text class="pa-0">
            <v-container>
              <v-row>
                <v-col>
                  <app-badge
                    item="ログインID"
                    :msg="$filter.message(`info_LoginId_vnumber`)"
                  ></app-badge>
                  <validation-provider
                    name="loginId"
                    label="ログインID"
                    v-model="form.loginId"
                    :rules="{ required: true, login_id_with_v_number: true }"
                    v-slot="{ componentField, errorMessage, meta }"
                  >
                    <app-form-input
                      v-bind="componentField"
                      :error-messages="errorMessage"
                      :field-meta="meta"
                    ></app-form-input>
                  </validation-provider>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <app-badge
                    item="メールアドレス"
                    :msg="$filter.message(`info_mail`)"
                  ></app-badge>
                  <v-label
                    >・メールアドレスはログインID情報として登録済みの情報をご指定ください。</v-label
                  >
                  <v-label
                    >・メールアドレスは大文字、小文字が区別されますのでご注意ください。</v-label
                  >
                  <validation-provider
                    name="email"
                    label="メールアドレス"
                    v-model="form.email"
                    :rules="{
                      required: true,
                      is_email: true,
                      max: { length: 127 },
                    }"
                    v-slot="{ componentField, errorMessage, meta }"
                  >
                    <app-form-input
                      v-bind="componentField"
                      :error-messages="errorMessage"
                      :field-meta="meta"
                    ></app-form-input>
                  </validation-provider>
                </v-col>
              </v-row>
              <div>再発行手続きを行うメールを送付します。よろしいですか？</div>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>
          <!-- FOOTER -->
          <v-card-actions>
            <v-list-item class="w-100 pa-1">
              <template v-slot:append>
                <v-btn type="submit" color="primary" variant="flat">送信</v-btn>
                <v-btn @click="cancel" variant="outlined" color="primary"
                  >キャンセル</v-btn
                >
              </template>
            </v-list-item>
          </v-card-actions>
        </v-form>
      </validation-observer>
    </template>
  </app-modal>
</template>

<script lang="ts">
import type { PostOnetime } from "@/apis/PasswordApi";
import { VueFinalModal } from "vue-final-modal";
import OneTimeUrlIssueModalComplete from "@/modals/password/OneTimeUrlIssueModalComplete.vue";
import { defineComponent } from "vue";

export default defineComponent({
  name: "OneTimeUrlIssueModal",
  data() {
    return {
      form: {
        loginId: "",
        email: "",
        oneTimeUrl: `${window.location.origin}/password/reset`,
      } as PostOnetime,
    };
  },
  methods: {
    async submit() {
      await this.$api.password.postOnetime(this.form);
      (this.$refs.modal as typeof VueFinalModal & { ok: () => void }).ok();
      await this.$modal.show(OneTimeUrlIssueModalComplete);
    },
  },
});
</script>
